module.exports = __webpack_public_path__ + "img/membership-banner.5da31328.jpg";